import { render, staticRenderFns } from "./authorizationswitch.vue?vue&type=template&id=30b204ab&"
import script from "./authorizationswitch.vue?vue&type=script&lang=ts&"
export * from "./authorizationswitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "authorizationswitch.vue"
export default component.exports